import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    queryUserAmountApi, //查询 用户 焕新币 余额接口
} from '@/api/apis/liveUser.js';

const createGuid = () => {
    return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const store = new Vuex.Store({
    state: {
        token: localStorage.getItem('hxpc_token') || '',
        user: localStorage.getItem('hxpc_user') ? JSON.parse(localStorage.getItem('hxpc_user')) : null,
        isLogin: localStorage.getItem('hxpc_token') ? true : false,
        uuid: localStorage.getItem('hxpc_uuid') || createGuid(),
        //	未成年保护配置信息
        wcnCfg: localStorage.getItem('hxpc_wcn_cfg') ? JSON.parse(localStorage.getItem('hxpc_wcn_cfg')) : null,
    },
    //commit
    mutations: {
        //查询用户 焕新币余额
        async queryUserAmount(state) { // null 为清空配置信息
            let oldUser = JSON.parse(JSON.stringify(state.user))
            if(!oldUser.hasOwnProperty('amount')){
                oldUser.amount = 0
                this.commit('updateUserInfo', oldUser) // 更新用户信息
            }
            queryUserAmountApi().then((res) => {
                oldUser.amount = res.data
                this.commit('updateUserInfo', oldUser) // 更新用户信息
            })
        },
        //	更新未成年保护配置
        async updateWcnCfg(state, data) { // null 为清空配置信息
            state.wcnCfg = data
            localStorage.setItem('hxpc_wcn_cfg', !data ? null : JSON.stringify(data))
        },
        //  更新用户信息
        async updateUserInfo(state, data) {
            state.user = data
            localStorage.setItem('hxpc_user', JSON.stringify(data))
        },
        //	登录
        async setLogin(state, data){
            await localStorage.setItem('hxpc_token', data.token)
            await localStorage.setItem('hxpc_user', JSON.stringify(data.user))
            state.token = data.token
            state.user = data.user
            state.isLogin = true
            //查询用户 焕新币余额
            this.commit('queryUserAmount')
        },
        //	退出登录
        async setLogout(state){
            await localStorage.removeItem('hxpc_token')
            await localStorage.removeItem('hxpc_user')
            await localStorage.removeItem('hxpc_uuid')
            state.token = ''
            state.user = null
            state.uuid = ''
            state.isLogin = false
        },
        //	设置uuid
        async setUUID(state, data){
            await localStorage.setItem('hxpc_uuid', data)
            state.uuid = data
        }
    },
    //dispatch
    actions: {
        // updateUserInfo(context) {
        //     context.commit("updateUserInfo");
        // }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js